<div class="kanban-page-container">
  @if (canAccessBoard()) {
    <app-kanban-board
      #kanban
      [boardId]="boardId"
      [actionsConfig]="columnActions"
      [fieldsToShow]="fieldsToShow"
      [productId]="'pista'"
      [boardFilters]="filters"
    ></app-kanban-board>
  }
</div>
